import { useCallback, useEffect, useMemo, useState } from "react"

const convertDomainUrl = (text: string) => {
    if (!text) return ""
    const pattern = /([\w+]+\:\/\/)?([\w\d-]+\.)*[\w-]+[\.\:]\w+([\/\?\=\&\#\.]?[\w-]+)*\/?/gm
    let output = ""
    let tokens = text.split(" ")
    for (const token of tokens) {
        if (token.match(pattern)) {
            output += `<a target="_blank" class="text-blue-60 underline break-all" href="${token.includes("http") ? token : "http://" + token}">${token}</a> `
        } else {
            output += token + " "
        }
    }
    return output
}

export function TextMessage({ text }: { text: string }) {
    
    const trustedHTML = useMemo(() => convertDomainUrl(text), [text])

    return (
        <div dangerouslySetInnerHTML={{ __html: trustedHTML }} className="text-sm whitespace-pre-wrap" >
        </div>
    )

}


// export function TextMessage({ text }: { text: string }) {
//     const [trustedHTML, setTrusted] = useState(
//         ""
//     )
//     const convertDomainUrl = (text: string) => {
//         if (!text) return
//         const pattern = /([\w+]+\:\/\/)?([\w\d-]+\.)*[\w-]+[\.\:]\w+([\/\?\=\&\#\.]?[\w-]+)*\/?/gm
//         let output = ""
//         let tokens = text.split(" ")
//         for (var token of tokens) {
//             if (token.match(pattern)) {
//                 output += `<a target="_blank" class="text-blue-60 underline break-all" href="${token.includes("http") ? token : "http://" + token}">${token}</a> `
//             } else {
//                 output += token + " "
//             }
//         }
//         setTrusted(output)
//     }
//     useEffect(() => {
//         convertDomainUrl(text)
//     }, [])
//     return (
//         <div dangerouslySetInnerHTML={{ __html: trustedHTML }} className="text-sm" >
//         </div>
//     )

// }